export function writeHtmlTo(document: Document, html: string) {
  document.open('replace');
  document.write(html);
  document.close();
}
